/*
 * <text-image-rows-image-carousel> is a fork of the theme's shared
 * <custom-content-slider> (also used by section-custom-content.liquid),
 * scoped to "Text + image rows" so it can run with wrapAround disabled
 * without changing that shared component's behavior elsewhere in the theme.
 * Like the original, it only runs Flickity at desktop widths (>=
 * theme.sizes.small) - each row's own mobile slides live in the separate
 * <text-image-rows-mobile-carousel> instead, so this one is torn down below
 * that breakpoint.
 */
if (!customElements.get('text-image-rows-image-carousel')) {
  class TextImageRowsImageCarousel extends HTMLElement {
    constructor() {
      super();
      this.checkSliderOnResize = () => this.checkSlider();
      this.resizeSliderEvent = () => this.resizeSlider();
      this.flkty = null;
    }

    connectedCallback() {
      this.checkSlider();
      document.addEventListener('theme:resize:width', this.checkSliderOnResize);
      this.addEventListener('theme:slider:resize', this.resizeSliderEvent);
    }

    checkSlider() {
      if (window.innerWidth >= window.theme.sizes.small) {
        this.initSlider();
        requestAnimationFrame(() => {
          this.dispatchEvent(new CustomEvent('theme:slider:resize', { bubbles: true }));
        });
        return;
      }
      this.destroySlider();
    }

    initSlider() {
      if (this.flkty !== null) return;
      if (this.querySelectorAll('[data-slide]').length > 1) {
        this.flkty = new window.theme.Flickity(this, {
          prevNextButtons: true,
          adaptiveHeight: true,
          pageDots: true,
          wrapAround: false,
          on: {
            change: () => this.changeTabIndex(),
          },
        });
        this.changeTabIndex();
      }
    }

    // Keeps only the active slide's links/buttons tab-focusable.
    changeTabIndex() {
      const selectedIndex = this.flkty.selectedIndex;
      this.flkty.slides.forEach((slide, index) => {
        slide.cells.forEach((cell) => {
          cell.element.querySelectorAll('a, button').forEach((el) => {
            el.setAttribute('tabindex', selectedIndex === index ? '0' : '-1');
          });
        });
      });
    }

    destroySlider() {
      if (this.flkty !== null) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    resizeSlider() {
      if (this.flkty !== null) {
        this.flkty.resize();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:resize:width', this.checkSliderOnResize);
      this.removeEventListener('theme:slider:resize', this.resizeSliderEvent);
    }
  }

  customElements.define('text-image-rows-image-carousel', TextImageRowsImageCarousel);
}
